export function getSeasonStartedMessage(roundOneKickoff) {
    const kickoffDate = new Date(roundOneKickoff);

    if (!roundOneKickoff || Number.isNaN(kickoffDate.getTime())) {
        return 'Season started! Round 1 kickoff is scheduled.';
    }

    return `Season started! Round 1 kicks off ${kickoffDate.toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short'
    })}.`;
}
